/*
 * 企業側 案件詳細
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_CREATE_CLIENT_RFP_OFFER_PAGE_VIEW = 'API_CREATE_CLIENT_RFP_OFFER_PAGE_VIEW';
/**
 * 提案PDF資料の閲覧の初回実行
 */
export const apiCreateClientRfpOfferPageView = ({ path: { id, page, view_request_id: viewRequestId } }, meta) => apiCreate(API_CREATE_CLIENT_RFP_OFFER_PAGE_VIEW, `client/rfp/${id}/offer/${viewRequestId}/page/${page}`, {}, meta);
